




















































































import { Component, Vue } from 'vue-property-decorator';

import Link from '../models/Link';
import TopBar from '../containers/TopBar.vue';

@Component({
    components: {
        TopBar
    },
})
export default class Navbar extends Vue {
    private mobileMenuOpen = false;
    private isMobile = false;
    private links: Link[] = [
        {
            name: 'Lobby',
            route: '/lobby',
            text: 'navbar.lobby',
        }, {
            name: 'Contests',
            route: '/contests',
            text: 'navbar.my_contests',
        },
        // {
        //     name: 'My Leagues',
        //     route: '/my-leagues',
        //     text: 'navbar.my_leagues',
        // },
        {
            name: 'Create',
            route: '/contests/create',
            text: 'Crear torneo',
        }, {
            name: 'Profile',
            route: '/profile',
            text: 'navbar.my_account',
        },
        // {
        //     name: 'Invite friends',
        //     route: '/profile/refer',
        //     text: 'shared.invite_friends',
        // },
        // {
        //     name: 'Help',
        //     route: '/contact',
        //     text: 'navbar.help',
        // },
    ];

    get activeRoute() {
        return this.$route;
    }

    private goTo(path: string) {
        this.$router.push(path)
    }

    onResize () {
        this.isMobile = window.innerWidth < 600
    }

    mounted() {
        this.onResize();
        window.addEventListener('resize', this.onResize, { passive: true })
    }

    beforeDestroy () {
        if (typeof window !== 'undefined') {
            (window as any).removeEventListener('resize', this.onResize, { passive: true })
        }
    }
}
